import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Headphones, NotebookPen } from 'lucide-react';
export function IncludesSection() {
  return <section id="includes" className="w-full bg-cream py-16 md:py-24" data-id="element-180">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-181">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-182">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-navy mb-12 text-center" data-id="element-183">
            Todo lo que recibes hoy — al instante
          </h2>

          <div className="grid md:grid-cols-3 gap-8 mb-12" data-id="element-184">
            <div className="bg-white rounded-lg shadow-lg p-8" data-id="element-185">
              <div className="flex justify-center mb-4" data-id="element-186">
                <BookOpen className="w-16 h-16 text-gold" data-id="element-187" />
              </div>
              <h3 className="text-xl font-serif font-bold text-navy mb-4 text-center" data-id="element-188">
                📘 Ebook principal en PDF
              </h3>
              <p className="text-center font-semibold text-navy mb-4" data-id="element-189">
                "30 Días con Dios" Orden, Provisión y Abundancia
              </p>
              <ul className="space-y-2 text-dark/80 text-sm" data-id="element-190">
                <li data-id="element-191">
                  • Introducción + 4 capítulos base: fe y neuroplasticidad,
                  coherencia interior, creencias limitantes y protocolo
                  R.E.V.E.L.A.
                </li>
                <li data-id="element-192">
                  • 30 días completos con promesa bíblica, declaración de fe,
                  práctica guiada y oración dirigida
                </li>
                <li data-id="element-193">
                  • Dividido en 4 semanas:{' '}
                  <strong data-id="element-194">
                    Limpieza → Alineación → Restauración → Constancia
                  </strong>
                </li>
                <li data-id="element-195">
                  • Checklists, diagnósticos, preguntas de reflexión y
                  worksheets por capítulo
                </li>
                <li data-id="element-196">• FAQ + Glosario + Bendición final (Números 6:24–26)</li>
              </ul>
            </div>

            <div className="bg-white rounded-lg shadow-lg p-8" data-id="element-197">
              <div className="flex justify-center mb-4" data-id="element-198">
                <Headphones className="w-16 h-16 text-gold" data-id="element-199" />
              </div>
              <h3 className="text-xl font-serif font-bold text-navy mb-4 text-center" data-id="element-200">
                🎧 4 Meditaciones Guiadas (MP4)
              </h3>
              <p className="text-center font-semibold text-gold mb-4" data-id="element-201">BONO 1</p>
              <ul className="space-y-2 text-dark/80 text-sm" data-id="element-202">
                <li data-id="element-203">• Una meditación al cierre de cada semana</li>
                <li data-id="element-204">
                  • Voz guiada + música para anclar lo aprendido en espíritu y
                  corazón
                </li>
                <li data-id="element-205">• Duración: 10–15 min cada una</li>
                <li data-id="element-206">
                  • Descargables y escuchables sin internet, cuando y donde lo
                  necesites
                </li>
              </ul>
            </div>

            <div className="bg-white rounded-lg shadow-lg p-8" data-id="element-207">
              <div className="flex justify-center mb-4" data-id="element-208">
                <NotebookPen className="w-16 h-16 text-gold" data-id="element-209" />
              </div>
              <h3 className="text-xl font-serif font-bold text-navy mb-4 text-center" data-id="element-210">
                📓 Libreta de Gratitud y Provisión
              </h3>
              <p className="text-center font-semibold text-gold mb-4" data-id="element-211">BONO 2</p>
              <p className="text-center font-semibold text-navy mb-4" data-id="element-212">
                PDF imprimible
              </p>
              <ul className="space-y-2 text-dark/80 text-sm" data-id="element-213">
                <li data-id="element-214">
                  • Un espacio sagrado para presentar tu proceso a Dios por
                  escrito, día a día
                </li>
                <li data-id="element-215">
                  • Plantillas diarias para escribir tu promesa del día, tu
                  declaración de fe, lo que hoy sueltas en oración y tu paso de
                  obediencia
                </li>
                <li data-id="element-216">
                  • Incluye un espacio para registrar tu evidencia del día:
                  dónde viste a Dios obrando hoy
                </li>
                <li data-id="element-217">
                  • Imprimible o usable en tablet: tú decides cómo caminar este
                  proceso
                </li>
              </ul>
            </div>
          </div>

          <blockquote className="border-l-4 border-gold pl-6 py-4 mb-8 bg-white rounded-r-lg max-w-3xl mx-auto" data-id="element-218">
            <p className="italic text-lg md:text-xl font-serif text-navy mb-2" data-id="element-219">
              "Dad gracias en todo, porque esta es la voluntad de Dios para con
              vosotros en Cristo Jesús."
            </p>
            <cite className="text-gold font-semibold not-italic" data-id="element-220">
              1 Tesalonicenses 5:18 (RVR60)
            </cite>
          </blockquote>

          <div className="text-center bg-navy text-white py-4 px-6 rounded-lg inline-block mx-auto" data-id="element-221">
            <p className="font-semibold" data-id="element-222">
              📲 Descarga inmediata — PDF + MP4 — Sin suscripciones — Sin
              esperas
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}